import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button, Table } from "reactstrap";
import { DeleteClassroom } from "../../../../store/ClassroomAdmin/ClassroomToolsAction";
import { ClassroomResult, CoreClassroomAdminClassroom, CoreClassroomAdminClassroomListing } from "../../../../models/CoreClassroomAdminClassroom";
import StatusCode from "../../../../util/StatusCode";
import Loading from "../../../misc/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


interface ClassroomViewToolDeleteClassroomProps {
    classrooms: CoreClassroomAdminClassroomListing[] | CoreClassroomAdminClassroom[]
}

const ClassroomViewToolDeleteClassroom = (props: ClassroomViewToolDeleteClassroomProps) => {
    const { t } = useTranslation(['common', "classroomAdmin"]);
    const dispatch = useDispatch();

    const [confirm, setConfirm] = useState<boolean>(false);
    const [deleteClassroomState, setDeleteClassroomState] = useState<ClassroomResult[]>([]);

    useEffect(() => {
        const state = props.classrooms.map(x => ({
            classroomId: x.classroomId,
            code: StatusCode.NONE,
        }));
        setDeleteClassroomState(state);
    }, []);

    const deleteClassroom = async () => {
        setConfirm(true);

        const state = props.classrooms.map(x => ({
            classroomId: x.classroomId,
            code: StatusCode.PENDING,
        }));
        setDeleteClassroomState(state);

        const results = await Promise.all(
            props.classrooms.map(x => DeleteClassroom(x.classroomId)(dispatch))
        );

        setDeleteClassroomState(results);
    };

    const renderStatus = (classroomId: string) => {
        var classroom = deleteClassroomState.find(x => x.classroomId === classroomId);
        if (!classroom) {
            return;
        }
        if (classroom.code === StatusCode.PENDING) {
            return <Loading />;
        }
        if (classroom.code === StatusCode.COMPLETE) {
            return (<>
                <FontAwesomeIcon icon="check" color="green" style={{ marginRight: '5px' }} />
                {t(`tools.DELETE_CLASSROOM.success`, { ns: 'classroomAdmin' })}
            </>);
        }
        if (classroom.code === StatusCode.ERROR) {
            const errorData = classroom?.error && classroom.error.response?.data as { title?: string; detail?: string } | undefined;
            const title = errorData?.title;
            const errorMessage = title ? t(`tools.errors.general.${title}`, { ns: 'classroomAdmin' }) : t(`error.somethingWentWrong`, { ns: 'common' });
            return (<>
                <FontAwesomeIcon icon="triangle-exclamation" color="red" style={{ marginRight: '5px' }} />
                {errorMessage}
            </>);
        }
    }

    return (
        <div>
            <p>{t(`tools.DELETE_CLASSROOM.confirmText`, { ns: 'classroomAdmin' })}</p>
            <Table striped>
                <thead>
                    <tr>
                        <th>{t('tools.tableHeader.classroom', { ns: 'classroomAdmin' })}</th>
                        <th>{t('tools.tableHeader.status', { ns: 'classroomAdmin' })}</th>
                    </tr>
                </thead>
                <tbody>
                    {props.classrooms.map(x => (
                        <tr key={x.classroomId}>
                            <td>{x.classroomName}</td>
                            <td>{renderStatus(x.classroomId)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            {!confirm && <Button onClick={() => deleteClassroom()}>{t('yes', { ns: 'common' })}</Button>}
        </div>
    );
}

export default ClassroomViewToolDeleteClassroom;

